import { IconProps } from '../../atoms/Icon';
import { TextProps } from '../../atoms/Text';
import { TextInputProps } from '../../atoms/TextInput';

type TextFieldInternalProps = {
  label?: TextProps;
  textInput?: TextInputProps;
  icon?: IconProps;
  text?: TextProps;
  required?: TextProps;
};

type TextFieldPropsValues = {
  'DefaultPasswordError': TextFieldInternalProps;
  'DefaultPasswordNone': TextFieldInternalProps;
  'DefaultTextError': TextFieldInternalProps;
  'DefaultTextNone': TextFieldInternalProps;
  'DefaultTextRequiredError': TextFieldInternalProps;
  'DefaultTextRequiredNone': TextFieldInternalProps;
  'HidePasswordError': TextFieldInternalProps;
  'HidePasswordNone': TextFieldInternalProps;
};

const propValues: TextFieldPropsValues = {
  'DefaultPasswordError': {
    label: {
      align: 'Left',
      styleType: 'Medium',
      colour: 'Dark',
      type: 'Button1',
    },
    textInput: {
      type: 'TextIcon',
      error: 'Error',
      size: 'M',
    },
    icon: {
      asset: 'Error',
      colour: 'IconDestructive',
    },
    text: {
      align: 'Left',
      styleType: 'Regular',
      colour: 'Destructive',
      type: 'Body4',
    },
  },
  'DefaultPasswordNone': {
    label: {
      align: 'Left',
      styleType: 'Medium',
      colour: 'Dark',
      type: 'Button1',
    },
    textInput: {
      type: 'TextIcon',
      error: 'None',
      size: 'M',
    },
  },
  'DefaultTextError': {
    label: {
      align: 'Left',
      styleType: 'Medium',
      colour: 'Dark',
      type: 'Button1',
    },
    textInput: {
      type: 'Text',
      error: 'Error',
      size: 'M',
    },
    icon: {
      asset: 'Error',
      colour: 'IconDestructive',
    },
    text: {
      align: 'Left',
      styleType: 'Regular',
      colour: 'Destructive',
      type: 'Body4',
    },
  },
  'DefaultTextNone': {
    label: {
      align: 'Left',
      styleType: 'Medium',
      colour: 'Dark',
      type: 'Button1',
    },
    textInput: {
      type: 'Text',
      error: 'None',
      size: 'M',
    },
  },
  'DefaultTextRequiredError': {
    label: {
      align: 'Left',
      styleType: 'Medium',
      colour: 'Dark',
      type: 'Button1',
    },
    required: {
      align: 'Left',
      styleType: 'Medium',
      colour: 'Destructive',
      type: 'Button1',
    },
    textInput: {
      type: 'Text',
      error: 'Error',
      size: 'M',
    },
    icon: {
      asset: 'Error',
      colour: 'IconDestructive',
    },
    text: {
      align: 'Left',
      styleType: 'Regular',
      colour: 'Destructive',
      type: 'Body4',
    },
  },
  'DefaultTextRequiredNone': {
    label: {
      align: 'Left',
      styleType: 'Medium',
      colour: 'Dark',
      type: 'Button1',
    },
    required: {
      align: 'Left',
      styleType: 'Medium',
      colour: 'Destructive',
      type: 'Button1',
    },
    textInput: {
      type: 'Text',
      error: 'None',
      size: 'M',
    },
  },
  'HidePasswordError': {
    label: {
      align: 'Left',
      styleType: 'Medium',
      colour: 'Dark',
      type: 'Button1',
    },
    textInput: {
      type: 'TextIcon',
      error: 'Error',
      size: 'M',
    },
    icon: {
      asset: 'Error',
      colour: 'IconDestructive',
    },
    text: {
      align: 'Left',
      styleType: 'Regular',
      colour: 'Destructive',
      type: 'Body4',
    },
  },
  'HidePasswordNone': {
    label: {
      align: 'Left',
      styleType: 'Medium',
      colour: 'Dark',
      type: 'Button1',
    },
    textInput: {
      type: 'TextIcon',
      error: 'None',
      size: 'M',
    },
  },
};

const getProps = (type: string): TextFieldInternalProps => {
  const values: TextFieldInternalProps = propValues[type];
  if (!values) {
    console.error(`${type} props not found`);
    return {};
  }
  return values;
};

export default getProps;
